import { render, staticRenderFns } from "./yigeUnitInfo.vue?vue&type=template&id=71f5d1e8&scoped=true&"
import script from "./yigeUnitInfo.vue?vue&type=script&lang=js&"
export * from "./yigeUnitInfo.vue?vue&type=script&lang=js&"
import style0 from "./yigeUnitInfo.vue?vue&type=style&index=0&id=71f5d1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5d1e8",
  null
  
)

export default component.exports